<template>
  <div>
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn class="extra-small" color="primary" fab outline v-on="on">
          <span class="fas fa-ellipsis-v"></span>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in items" :key="index" @click="insertPrefill(item.value)">
          <v-list-tile-title class="primary-color">{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      items: [
        {
          title: this.$t('Address'),
          value: '{address}'
        },
        {
          title: this.$t('AddressAndPhone'),
          value: '{addressandphone}'
        },
        {
          title: this.$t('Phone'),
          value: '{phone}'
        },
        {
          title: this.$t('Email'),
          value: '{email}'
        },
        {
          title: this.$t('Province'),
          value: '{province}'
        },
        {
          title: this.$t('Number'),
          value: '{number}'
        },
        {
          title: this.$t('Date'),
          value: '{date}'
        }
      ]
    }
  },
  methods: {
    insertPrefill: function(value) {
      this.$emit('onAddPrefill', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefillQuestion.vue